<template>
  <div>
    <dropdown
      v-if="children"
      :trigger="'hover'"
      :role="'sublist'"
      :class-name="'tree-menu'"
      :align="'right'"
      :x="-40"
    >
      <template slot="btn">
        <router-link :to="link" v-slot="{ href, route, navigate }">
          <span
            :href="href"
            @click="
              navigate($event);
              onClick();
            "
            class="text-gray hover-primary pointer"
          >
            {{ $t(text) }}
          </span>
        </router-link>
      </template>
      <template slot="body">
        <tree-menu v-for="(child, i) in children" v-bind="child" :key="i">
        </tree-menu>
      </template>
    </dropdown>
    <div v-else>
      <router-link :to="link" v-slot="{ href, route, navigate }">
        <span
          :href="href"
          @click="
            navigate($event);
            onClick();
          "
          class="text-gray hover-primary pointer"
        >
          {{ $t(text) }}
        </span>
      </router-link>
    </div>
  </div>
</template>
<script>
import Dropdown from "bp-vuejs-dropdown";
import { mapMutations } from "vuex";

export default {
  props: ["text", "children", "link", "event"],
  name: "tree-menu",
  components: {
    Dropdown,
  },
  methods: {
    ...mapMutations(["toggleComposeModal"]),
    onClick() {
      if (this.event == "openComposeModal") this.toggleComposeModal(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-menu-bp__body {
  color: black;
}

.hover-primary:hover {
  color: var(--color-primary) !important;
}
</style>
